/**
 * DataCard Component
 * Generic card component for use in DataView card mode
 */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./DataCard.scss";

export const DataCard = React.memo(({
  to,
  header,
  body,
  footer,
  actions,
  size = "normal",
  className = "",
}) => {
  const CardWrapper = to ? Link : "div";
  const wrapperProps = to ? { to } : {};

  return (
    <CardWrapper
      className={`data-card data-card--${size} ${className}`}
      {...wrapperProps}
    >
      {(header || actions) && (
        <div className="data-card__header">
          <div className="data-card__header-content">{header}</div>
          {actions && <div className="data-card__actions">{actions}</div>}
        </div>
      )}

      {body && <div className="data-card__body">{body}</div>}

      {footer && <div className="data-card__footer">{footer}</div>}
    </CardWrapper>
  );
});

DataCard.propTypes = {
  to: PropTypes.string,
  header: PropTypes.node,
  body: PropTypes.node,
  footer: PropTypes.node,
  actions: PropTypes.node,
  size: PropTypes.oneOf(["compact", "normal", "expanded"]),
  className: PropTypes.string,
};
